export class VennHelper
{
    static setKey(arr)
    {
        return (arr || []).slice().sort((a, b) => a - b).join(',');
    }

    /**
     * Конвертирует exact-области (эксклюзивные) в структуру для venn.js:
     * - size: inclusive (для корректной геометрии)
     * - exactSize: exact (для tooltip/смысла клика)
     *
     * @param {{sets:number[], size:number}[]} joins
     * @return {{inclusive: Object<string, number>, exact: Object<string, number>}}
     */
    static buildInclusiveFromExactJoins(joins)
    {
        const exact = {};
        (joins || []).forEach((j) => {
            if (!j || !j.sets || !j.sets.length) return;
            exact[this.setKey(j.sets)] = Number(j.size || 0);
        });

        const inclusive = {};
        const addToAllSubsets = (arr, value) => {
            const a = (arr || []).slice().sort((x, y) => x - y);
            const n = a.length;
            for (let mask = 1; mask < (1 << n); mask++) {
                const subset = [];
                for (let i = 0; i < n; i++) {
                    if (mask & (1 << i)) subset.push(a[i]);
                }
                const k = this.setKey(subset);
                inclusive[k] = (inclusive[k] || 0) + value;
            }
        };

        Object.entries(exact).forEach(([k, v]) => {
            const arr = k === '' ? [] : k.split(',').map(Number);
            addToAllSubsets(arr, v);
        });

        return { inclusive, exact };
    }

    /**
     * Собирает датасет venn.js из доменов + exact-joins.
     *
     * @param {{id:number, name:string}[]} domains
     * @param {{sets:number[], size:number}[]} joins
     * @param {string} sizeKey fallback-ключ для одиночных кругов (it50/numdomain/adkeyscnt)
     * @param {(id:number) => any} colorResolver
     * @return {{sets:number[], label?:string, size:number, exactSize?:number, color?:any}[]}
     */
    static buildVennSets(domains, joins, sizeKey, colorResolver = null)
    {
        const { inclusive, exact } = this.buildInclusiveFromExactJoins(joins);
        const result = [];

        (domains || []).forEach((d) => {
            const k1 = this.setKey([d.id]);
            result.push({
                sets: [d.id],
                label: d.name,
                size: (inclusive[k1] ?? d[sizeKey]),
                exactSize: exact[k1] ?? 0,
                color: colorResolver ? colorResolver(d.id) : undefined,
            });
        });

        Object.entries(inclusive).forEach(([k, inc]) => {
            const arr = k === '' ? [] : k.split(',').map(Number);
            if (arr.length <= 1) return;
            result.push({
                sets: arr,
                size: inc,
                exactSize: exact[k] ?? 0,
                color: colorResolver ? colorResolver(arr[0]) : undefined,
            });
        });

        return result;
    }
}

